import { useTranslation } from 'react-i18next';

export function useLanguageCode() {
    const { i18n } = useTranslation();

    // TODO(evanmh): We can probably do this better.
    return i18n.language.split('-')[0];
}
